import React from 'react';
import { Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useStyles, { ToolbarWrapper } from './styles';
import Tabs from '@material-ui/core/Tabs';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const TabsMap = ['Accommodations', 'Activities'];

const ToolbarTabs = ({ tab, onChangeTab }) => {
  const [t] = useTranslation();
  const { root, wrapper, selected, textColorInherit } = useStyles();

  return (
    <ToolbarWrapper>
      <Tabs indicatorColor="primary" value={tab} onChange={onChangeTab}>
        {TabsMap.map((tabName, index) => (
          <Tab
            key={tabName}
            classes={{ root, wrapper, selected, textColorInherit }}
            label={`${t(tabName)}`}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
    </ToolbarWrapper>
  );
};

export default ToolbarTabs;
